(() => {
  if (window._noxteeCheckoutChampProductionHandoffReady) return;

  const productId = '7996565913665';
  const variantMap = Object.freeze({
    '44266883940417': '63.17:1',
    '44266883973185': '83.19:1',
    '44266884005953': '85.21:1',
  });
  const allowedProducts = new Set(Object.values(variantMap));

  const resetOfferState = (root = document) => {
    root.querySelectorAll('[data-nx-bundle-offer]').forEach((offer) => {
      delete offer.dataset.nxCheckoutchampRedirecting;
      offer.querySelectorAll('[aria-busy="true"]').forEach((control) => control.removeAttribute('aria-busy'));
      offer.querySelectorAll('[data-testid="noxtee-bundle-add-to-cart"]').forEach((button) => {
        const selected = offer.querySelector('[data-nx-bundle-input]:checked');
        button.disabled = selected?.dataset.variantAvailable !== 'true';
      });
    });
  };

  const getRoute = (offer) => {
    if (offer?.dataset.productId !== productId) return null;

    const selectedVariant = offer.querySelector('[data-nx-bundle-input]:checked')?.value;
    const products = variantMap[selectedVariant];
    if (!allowedProducts.has(products)) return null;

    const checkoutUrl = new URL('https://checkout.noxtee.com/');
    checkoutUrl.searchParams.set('products', products);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (key !== 'products') checkoutUrl.searchParams.append(key, value);
    });

    return checkoutUrl.toString();
  };

  const redirect = (offer, control) => {
    const route = getRoute(offer);
    if (!route || offer.dataset.nxCheckoutchampRedirecting === 'true') return false;

    offer.dataset.nxCheckoutchampRedirecting = 'true';
    control?.setAttribute('aria-busy', 'true');
    if (control instanceof HTMLButtonElement) control.disabled = true;
    window.location.assign(route);

    window.setTimeout(() => {
      delete offer.dataset.nxCheckoutchampRedirecting;
      control?.removeAttribute('aria-busy');
      if (control instanceof HTMLButtonElement) control.disabled = false;
    }, 5000);

    return true;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target?.closest?.('form[data-type="add-to-cart-form"]');
    const offer = form?.closest('[data-nx-bundle-offer]');
    if (!getRoute(offer)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    redirect(offer, form.querySelector('[ref="addToCartButton"]'));
  }, true);

  const getStickyOffer = (control) => {
    const section = control?.closest('.shopify-section');
    return section?.querySelector(`[data-nx-bundle-offer][data-product-id="${productId}"]`);
  };

  document.addEventListener('pointerdown', (event) => {
    const stickyButton = event.target?.closest?.('.nx-satc__button');
    const offer = getStickyOffer(stickyButton);
    if (!stickyButton || !getRoute(offer)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    redirect(offer, stickyButton);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const stickyButton = event.target?.closest?.('.nx-satc__button');
    const offer = getStickyOffer(stickyButton);
    if (!stickyButton || !getRoute(offer)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    redirect(offer, stickyButton);
  }, true);

  document.addEventListener('click', (event) => {
    const stickyButton = event.target?.closest?.('.nx-satc__button');
    if (!stickyButton) return;

    const offer = getStickyOffer(stickyButton);
    if (!getRoute(offer)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    redirect(offer, stickyButton);
  }, true);

  // Safari and mobile browsers can restore the page from the back-forward cache
  // before redirect cleanup timers run. Clear transient purchase state both before
  // the page is cached and whenever it becomes active again.
  window.addEventListener('pagehide', () => resetOfferState());
  window.addEventListener('pageshow', () => resetOfferState());
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') resetOfferState();
  });

  window._noxteeCheckoutChampProductionHandoffReady = true;
})();
